<template>
  <div class="ak-kanban">
    <template v-for="(column, index) in columns" :key="index">
      <ak-kanban-column
        v-model:data="columnData[column]"
        v-model:total="columnTotals[column]"
        :name="column"
        :index="index"
        :per-page="perPage"
        :component="component"
        :fetch="fetchWrap(column)"
        :column-arrow="columnArrow"
      />
    </template>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import KanbanColumn from './KanbanColumn.vue'

export default defineComponent({
  name: 'AkKanban',

  components: {
    [KanbanColumn.name]: KanbanColumn,
  },

  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    component: {
      type: Object,
      default: () => ({}),
    },
    fetch: {
      type: Function,
      default: () => {},
    },
    columnArrow: {
      type: Boolean,
      default: true,
    },
    perPage: {
      type: Number,
      default: 20,
    },
  },

  setup(props) {
    const columnTotals = ref({})

    const columnData = ref(props.columns.reduce((a, i) => (a[i] = []), {}))

    const isCol = (col) => Array.isArray(columnData.value[col])

    const createCol = (col, { data, total }) => {
      columnData.value[col] = [].concat(data)
      columnTotals.value[col] = total
    }

    const updateCol = (col, { data, total }) => {
      columnData.value[col] = columnData.value[col].concat(data)
      columnTotals.value[col] = total
    }

    const fetchWrap = (col) => {
      return async ({ perPage, page }) => {
        const data = await props.fetch({ col, page, perPage })
        if (isCol(col)) {
          updateCol(col, data)
        } else {
          createCol(col, data)
        }
      }
    }

    return {
      columnData,
      columnTotals,
      fetchWrap,
    }
  },
})
</script>

<style lang="scss">
@import '../../scss/_settings.scss';
.ak-kanban {
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  height: 100%;
}
</style>
